import { takeLatest, call, put } from "redux-saga/effects"
import axios from "axios"
import { generateTree } from "utils/utils"
import {
  filtersSuccess,
  filtersFailed,
  getPlansSuccess,
  getPlansFailed,
  getTemplateSuccess,
  getTemplateFailed,
  getTemplateTaskSuccess,
  getTemplateTaskFailed,
  getSurveys,
  getSurveysFailed,
  getSurveysSuccess,
} from "./actions"
import {
  FILTERS_WATCHER,
  GET_PLANS_WATCHER,
  GET_TEMPLATE_TASK_WATCHER,
  GET_TEMPLATE_WATCHER,
  GET_SURVEYS_WATCHER,
} from "./constants"
import { LOCAL_TOKEN } from "../../../utils/storage"
import {
  getTemplateTaskApi,
} from "../../../utils/routes/routes-action-plans"

function messageProgress(messagex) {
  message.loading(messagex, 0)
}

function messageDestroy() {
  message.destroy()
}

function messageError(messagex) {
  message.error(messagex)
}

function messageSuccess(messagex) {
  message.success(messagex)
}

function donwloadTemplate(url) {
  location.replace(url)
}

function downloadTemplate(url) {
  location.replace(url)
}

function getTemplateApi(id_measure) {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}action-plans/export/xlsx/?id_measure=${id_measure}`,
  })
}

function getTemplateApiProgress() {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}action-plans/export/xlsx/progress`,
    validateStatus: () => true, // I'm always returning true,
  })
}

function getSurveysByDivision(data) {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}measure/${data.measure_id}/division/${data.division_id}/surveys`,
  })
}

export function* getSurveysSaga(action) {
  try {
    const { data } = yield call(getSurveysByDivision, action.payload)
    yield put(getSurveysSuccess(data))
  } catch (error) {
    returnMessage(error)
    yield put(getSurveysFailed(error))
  }
}

// GET FILTERS
export function* getFilterSaga(action) {
  try {
    const {
      data: { data },
    } = yield call(fetchGlobalApi, {
      method: "GET",
      endpoint: "action-plans/filters",
      data: action.payload,
    })
    data.result.dimensions = generateTree(
      "id_dimension",
      "id_dimension_parent",
      [
        ...JSON.parse(JSON.stringify(data.result.dimensions)),
        ...JSON.parse(JSON.stringify(data.result.dimensions)),
      ]
    )
    yield put(filtersSuccess(data.result))
  } catch (error) {
    returnMessage(error)
    filtersFailed({})
  }
}

// GET PLANS
export function* getPlansSaga(action) {
  try {
    const {
      data: { data },
    } = yield call(fetchGlobalApi, {
      method: "GET",
      endpoint: "action-plans",
      params: action.payload,
    })
    const result = {
      sidebar_ambassadors: data.result.embajadores,
      sidebar_divisions: data.result.divisions,
      plans: data.result.action_plans,
      count_action_plans: data.result.count_action_plans,
      resume: data.result.resume,
    }
    yield put(getPlansSuccess(result))
  } catch (error) {
    returnMessage(error)
    getPlansFailed({})
  }
}

// GET EXPORT
export function* getTemplateSaga(action) {
  try {
    yield call(messageProgress, "Descargando archivo")
    yield call(getTemplateApi, action.payload)
    let data
    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 2000))
      data = yield call(getTemplateApiProgress)
      if (data.status === 200) {
        yield call(donwloadTemplate, data.data.data.result[0].url)
        yield call(messageDestroy)
        returnMessage(data)
        yield put(getTemplateSuccess())
        break
      }
      if (data.status === 500) {
        yield call(messageDestroy)
        message.error(data.data.data.error, 5)
        yield put(getTemplateFailed())
        break
      }
    }
  } catch (e) {
    yield call(messageDestroy)
    returnMessage(e)
    yield put(getTemplateFailed())
  }
}

// GET EXPORT TASK
export function* getTemplateTaskSaga(action) {
  try {
    yield call(messageProgress, "Descargando archivo")
    const { data } = yield call(getTemplateTaskApi, action.payload)
    yield call(downloadTemplate, data.msj.url)
    yield call(messageDestroy)
    yield call(messageSuccess, "Archivo descargado")
    /*
    let data
    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 2000))
      data = yield call(getTemplateTaskProgressApi)
      if (data.status === 200) {
        yield call(downloadTemplate, data.data.result[0].url)
        yield call(messageDestroy)
        returnMessage(data)
        yield put(getTemplateTaskSuccess())
        break
      }
      if (data.status === 500) {
        yield call(messageDestroy)
        message.error(data.data.error, 5)
        yield put(getTemplateTaskFailed())
        break
      }
    } */
  } catch (e) {
    yield call(messageDestroy)
    yield call(messageError, "Error al descargar archivo")
    // returnMessage(e)
    yield put(getTemplateTaskFailed())
  }
}

// Individual exports for testing
export default function* actionPlansSaga() {
  yield takeLatest(FILTERS_WATCHER, getFilterSaga)
  yield takeLatest(GET_PLANS_WATCHER, getPlansSaga)
  yield takeLatest(GET_TEMPLATE_WATCHER, getTemplateSaga)
  yield takeLatest(GET_TEMPLATE_TASK_WATCHER, getTemplateTaskSaga)
  yield takeLatest(GET_SURVEYS_WATCHER, getSurveysSaga)
}
